// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"184":"baabde533bd8b13c","189":"2f6e535d32ff5a64"}[chunkId] + ".js";
};